import { isAgentHubAgencySavedCardsEnabled } from 'agentHub/selectors/agentHubSelectors'
import { getCartHasPropertyCollectItem } from 'checkout/selectors/payment/propertyCollectSelectors'
import { isStandaloneGiftCard } from 'checkout/selectors/view/giftCard'
import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'

const getPersonalSavedCards = (state: App.State): Array<App.StripePaymentCard | App.StripePaymentCardV2> => state.auth.account.stripePaymentCards ?? EmptyArray

const getAgencySavedCards = (state: App.State): Array<App.StripePaymentCardV2> => state.auth.account.agentHubAgencyStripePaymentCards ?? EmptyArray

function withSavedCardOwner<T extends App.StripePaymentCard | App.StripePaymentCardV2>(card: T, savedCardOwner: App.CheckoutSavedCardOwner): App.CheckoutStripePaymentCard {
  return {
    ...card,
    savedCardOwner,
  }
}

function isDefaultSavedCard(card: App.StripePaymentCard | App.StripePaymentCardV2): boolean {
  return ('isDefault' in card && !!card.isDefault) || ('is_default_source' in card && !!card.is_default_source)
}

function sortDefaultCardFirst<T extends App.StripePaymentCard | App.StripePaymentCardV2>(cards: Array<T>): Array<T> {
  return [...cards].sort((leftCard, rightCard) => Number(isDefaultSavedCard(rightCard)) - Number(isDefaultSavedCard(leftCard)))
}

export const getCheckoutSavedPaymentCards = createSelector(
  getPersonalSavedCards,
  getAgencySavedCards,
  (personalSavedCards, agencySavedCards): Array<App.CheckoutStripePaymentCard> => {
    if (!isAgentHubAgencySavedCardsEnabled) {
      return personalSavedCards
    }

    return [
      ...sortDefaultCardFirst(personalSavedCards).map(card => withSavedCardOwner(card, 'personal')),
      ...sortDefaultCardFirst(agencySavedCards).map(card => withSavedCardOwner(card, 'agency')),
    ]
  },
)

export const getVisibleCheckoutSavedPaymentCards = createSelector(
  getCheckoutSavedPaymentCards,
  (state: App.State) => isStandaloneGiftCard(state),
  (state: App.State) => getCartHasPropertyCollectItem(state),
  (savedCards, standaloneGiftCard, hasPropertyCollectItem): Array<App.CheckoutStripePaymentCard> => {
    if (standaloneGiftCard || hasPropertyCollectItem) return EmptyArray

    return savedCards
  },
)
